<div class="help-container">
	<h1>Getting Started</h1>
	<iframe width="560" height="315" src="https://www.youtube.com/embed/MIeAoDVOHNo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
	<p>
		<input type="button" value="Continue to Your Store" (click)="onContinueClick()">
	</p>
</div>
